import { PaymentAddressSettingsInterface } from '@pe/checkout/types';


export const HAS_NODE_FORM_OPTIONS = false;
export const BILLING_ADDRESS_SETTINGS: PaymentAddressSettingsInterface = null;
export const IVY_BUTTON_SCRIPT = 'https://cdn.getivy.de/button.js';
